export const FundPattern = /^(?<name>[\w]+)-(?<class>[ABCM]+)$/

export enum FundID {
  SOF_A = 'SOF-A',
  SOF_B = 'SOF-B',
  SOF_C = 'SOF-C',
  SOF_M = 'SOF-M',
  GCMF_A = 'GCMF-A',
  GCMF_B = 'GCMF-B',
  GCMF_C = 'GCMF-C',
  GCMF_M = 'GCMF-M',
  UGWAF_A = 'UGWAF-A',
  UGWAF_B = 'UGWAF-B',
  UGWAF_C = 'UGWAF-C',
  UGWAF_M = 'UGWAF-M',
}

export enum FundName {
  'SOF-A' = 'UG Hidden Dragon Special Opportunity Fund - A Class',
  'SOF-B' = 'UG Hidden Dragon Special Opportunity Fund - B Class',
  'SOF-C' = 'UG Hidden Dragon Special Opportunity Fund - C Class',
  'SOF-M' = 'UG Hidden Dragon Special Opportunity Fund - M Class',
  'GCMF-A' = 'UG Greater China Multi-Strategy Fund - A Class',
  'GCMF-B' = 'UG Greater China Multi-Strategy Fund - B Class',
  'GCMF-C' = 'UG Greater China Multi-Strategy Fund - C Class',
  'GCMF-M' = 'UG Greater China Multi-Strategy Fund - M Class',
  'UGWAF-A' = 'UG Great Wall Absolute Return Fund - A Class',
  'UGWAF-B' = 'UG Great Wall Absolute Return Fund - B Class',
  'UGWAF-C' = 'UG Great Wall Absolute Return Fund - C Class',
  'UGWAF-M' = 'UG Great Wall Absolute Return Fund - M Class',
}
